/**
 * Created by Pierrot on 08/10/2014.
 */
'use strict';
import * as _ from 'lodash';

module.exports = function (angular) {

    return { 
        gamelog: function(){

            let _history = [];

            return {
                reset(){
                    _history = [];
                },
                add(msg){
                    _history.push(msg);
                },
                getHistory(){
                    return _history;
                }
            }
        }
    }
}